import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { flatten, groupBy, values } from 'lodash';
import { DatePicker } from 'antd';
import moment from 'moment';
import Tooltip from '@/components/tooltip';
import Chart from '@/business-components/chart';
import Pie from '@/components/charts/pie';
// import { ConBrandDetailsWebController } from '@/services/swagger/ConBrandDetailsWebController';
import Dot from '@/components/Dot';
import CustomEmpty from '@/business-components/CustomEmpty';
import { defaultMonthVal } from '../../../index.page';
import styles from './index.module.scss';

// const brandDetailController = new ConBrandDetailsWebController();
export default function UserOpinion({ data, hasUnlock }) {
  // console.log(data);
  const [viewData, setViewData] = useState<any>(flatten(data?.map(item => item.list)));
  const [dateValue, setDateValue] = useState(defaultMonthVal);

  const [dateRange, setDateRange] = useState([]);
  const disabledDate2 = useCallback(
    (current): boolean => dateRange.every(item => item !== current.format('YYYY-MM')),
    [dateRange]
  );
  useEffect(() => {
    const value: any = values(
      groupBy(
        flatten(data?.map(item => item.list))?.filter(
          (item: any) => moment(item?.countTimeStr).month() === moment(dateValue).month()
        ),
        'conBrandId'
      )
    );
    setViewData(value);
  }, [data, dateValue]);
  // const handleDateChange = useCallback(
  //   async val => {
  //     let dataArr = [];
  //     await selectList?.map(async item => {
  //       const {
  //         data: { data: userOpinion },
  //       } = await brandDetailController.conBrandDetailsWebControllerV1SocialUserOpinionUsingGet1({
  //         conBrandId: item?.conBrandId,
  //         month: moment(val).month() + 1,
  //         yearStr: moment(val).year(),
  //       });
  //       dataArr = [...dataArr, { ...item, list: userOpinion?.brandEvaluateList }];
  //       setViewData(dataArr);
  //     });
  //   },
  //   [selectList]
  // );
  const handleDateChange = useCallback(
    val => {
      setDateValue(val);
      setViewData(
        val
          ? flatten(data?.map(item => item.list))?.filter(
              (item: any) => moment(item?.countTimeStr).month() === moment(val).month()
            )
          : flatten(data?.map(item => item.list))
      );
    },
    [data]
  );
  useEffect(() => {
    // handleDateChange(moment());

    const valueDateRange: any = [
      ...new Set(
        flatten(data?.map(item => item.list))
          ?.sort(
            (item: any, itemB: any) => moment(item?.countTimeStr).valueOf() - moment(itemB?.countTimeStr).valueOf()
          )
          .map((item: any) => item?.countTimeStr)
      ),
    ];
    // console.log(valueDateRange);
    setDateRange(valueDateRange);
    setDateValue(
      valueDateRange.length ? moment(valueDateRange[valueDateRange.length - 1], 'YYYY-MM') : defaultMonthVal
    );
  }, [data, handleDateChange]);
  return (
    <div className={classNames('flex-row-wrap', 'flex-start-center', styles.userOpinion)}>
      <div className={styles.brandIndex}>
        <Chart
          title={
            <span className={styles.title}>
              品牌舆情分析
              <Tooltip
                title={
                  <>
                    <p>小红书平台中品牌相关笔记的评论舆情正负向占比。</p>
                    <p>数据来源：千瓜数据</p>
                  </>
                }
                placement="right"
                style={{ marginRight: '33px' }}
              />
              {hasUnlock && (
                <DatePicker
                  picker="month"
                  allowClear={false}
                  defaultValue={defaultMonthVal}
                  onChange={handleDateChange}
                  value={dateValue}
                  disabledDate={disabledDate2}
                />
              )}
            </span>
          }
          titleFontSize={16}
          dateSubTitle={false}
          panelClassName={styles.card}
        >
          {hasUnlock ? (
            <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.mapContent)}>
              {viewData?.map((item, index) => (
                <div className={styles.mapItem} key={index}>
                  <div className={classNames('flex-row-nowrap', 'flex-start-center')}>
                    <Dot style={{ marginRight: '4px' }} />
                    {item?.[0]?.chName}
                  </div>
                  <Pie
                    data={item || []}
                    xField="value"
                    yField="dataTypeName"
                    height={236}
                    tooltip={(_title, items) => {
                      return (
                        <div className={styles.tooltip}>
                          <p>
                            {items[0]?.name}：<span>{items[0]?.data?.value}%</span>
                          </p>
                        </div>
                      );
                    }}
                  />
                </div>
              ))}
            </div>
          ) : (
            <CustomEmpty text="已选择的品牌中有未解锁的品牌，请解锁后查看" />
          )}
        </Chart>
      </div>
    </div>
  );
}
